/**
 * These types and enums are duplicated here **temporarily** to aid in removing the @doxyme/media library.
 * These types are here specifically as they were being used in libs/ui and libs/business-services.
 * Once all usages of these types are removed from libs/ui and libs/business-services, these types should be moved to apps/frontend/webrtc/media.
 * @TODO https://doxyme.atlassian.net/browse/PE-2222
 */

export enum Vendor {
  Vonage = 'Vonage',
}

export type VirtualBackgroundFilter = {
  type: 'backgroundBlur' | 'backgroundReplacement';
  blurStrength?: 'low' | 'high';
  backgroundImgUrl?: string;
};

export enum MediaAccessError {
  PermissionDenied = 'PermissionDenied',
  PermissionDeniedBySystem = 'PermissionDeniedBySystem',
  DeviceNotFound = 'DeviceNotFound',
  IncorrectConstraints = 'IncorrectConstraints',
  NoVideoAudioConstraints = 'NoVideoAudioConstraints',
  Error = 'Error',
}
